import React /*, { useState, useEffect } */ from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentStatus from './PaymentStatus';
import './styles.css';

const PUBLIC_KEY = window.sessionStorage.getItem('publishableKey');
const stripePromise = loadStripe(PUBLIC_KEY);
const callBack = '/checkout';
export default function OrderCardAdded() {
  return (
    <Elements stripe={stripePromise}>
      <PaymentStatus callBack={callBack} />
    </Elements>
  );
}
